import { createSelector } from 'reselect';
import { getCurrentUser } from '../user/user.selectors';
import find from 'lodash/find';
import keys from 'lodash/keys';
import without from 'lodash/without';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import sumBy from 'lodash/sumBy';

const allIds = (state) => state.entities.team.allIds;
const byId = (state) => state.entities.team.byId;
const ranking = (state) => state.entities.team.ranking;

const usersById = (state) => state.entities.user.byId;

export const getAllTeams = createSelector(
  [ byId, allIds ],
  (teams, ids) => {
    return ids.map(id => teams[id]);
  }
);

export const getAllTeamsWithAdminUser = createSelector(
  [ getAllTeams ],
  (teams) => {
    return teams.filter(team => team.adminUser);
  }
);

export const getCurrentUserTeam = createSelector(
  [ byId, getCurrentUser ],
  (teams, currentUser) => {
    if(!currentUser.team) return null;
    return teams[currentUser.team._id] || [];
  }
);

export const getUsersForCurrentUserTeam = createSelector(
  [ getCurrentUserTeam, usersById ],
  (userTeam, users) => {
    const members = userTeam.members ? userTeam.members.map(id => users[id]) : [];
    return without(members, undefined);
  }
);

export const getScoresForCurrentUserTeam = createSelector(
  [ getUsersForCurrentUserTeam ],
  (users) => {
    return reverse(sortBy(users, 'score'));
  }
);

export const getTotalScoreForCurrentUserTeam = createSelector(
  [ getScoresForCurrentUserTeam ],
  (users) => {
    return sumBy(users, 'score');
  }
);

//TODO
export const getTopTeamScores = createSelector(
  [ byId, ranking ],
  (teams, scores) => {
    const scoresArr = keys(scores).map(id => scores[id]);
    return scoresArr.map((score, index) => {
      return {
        position: index+1,
        score: score.score,
        team: teams[score.team]
      };
    });
  }
);

//TODO
export const getCurrentUserTeamPosition = createSelector(
  [ getTopTeamScores, getCurrentUserTeam ],
  (ranking, currentUserTeam) => {
    if(currentUserTeam) {
      const currentTeamRanking = find(ranking, (item) => {
        return item.team._id === currentUserTeam._id;
      });

      if(currentTeamRanking) {
        return currentTeamRanking.position;
      }
    }
    
    return null;
  }
);


// WEBPACK FOOTER //
// ./src/modules/team/team.selectors.js